/* eslint camelcase: 0 */
import { Pharmaceutical, PharmaceuticalRequest } from '@/infrastructure/network/Monitaro/schema/models'
import { IPharmaceuticalProps, EmptyPharmaceuticalPropsFactory } from '@/entities/Pharmaceutical'

export const toPharmaceuticalProps = (props: Pharmaceutical | null | undefined): IPharmaceuticalProps => {
  if (!props) {
    return EmptyPharmaceuticalPropsFactory()
  }

  const { id, company_id, name, properties, order, created_at, updated_at } = props

  return EmptyPharmaceuticalPropsFactory({
    id,
    companyId: company_id,
    name,
    properties,
    order,
    createdAt: created_at,
    updatedAt: updated_at
  })
}

export const toPharmaceuticalRequest = (props: IPharmaceuticalProps): PharmaceuticalRequest => {
  const { name, companyId, properties } = props
  return {
    name: name!,
    company_id: companyId!,
    properties: properties!
  }
}
